var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.889,
    height: 35,
    viewBox: "0 0 27.889 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Completed",
    transform: "translate(-3.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M27.806,9.806A7.566,7.566,0,0,1,29.618,12a7.566,7.566,0,0,1,.271,2.833V27.889c0,3.352,0,5.028-1.041,6.07S26.13,35,22.778,35H12.111c-3.352,0-5.028,0-6.07-1.041S5,31.241,5,27.889V10.111c0-3.352,0-5.028,1.041-6.07S8.759,3,12.111,3h5.943a7.564,7.564,0,0,1,2.833.271,7.564,7.564,0,0,1,2.2,1.812Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#878a99",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M9,15.556l2.8,2.8h0a1.063,1.063,0,0,0,1.5,0h0L19.667,12",
    transform: "translate(3.111 7)",
    fill: "none",
    stroke: "#878a99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.4828f86792f3dffb77f6c83739ae5007.svg";
export { ForwardRef as ReactComponent };